// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_11G3I0","iconContainer":"Gn_toO","icon":"_2MwDIY"};